import buildComponent from './utils/build-component';

export default (nameSpace) => buildComponent({
  nameSpace,
  initState: {
    scrollTop: 0,
  },
  initFunction: ($el, params) => {
    let ticking = false;

    //
    // Methods
    //

    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          params.setState({ scrollTop: document.documentElement.scrollTop || document.body.scrollTop });
          ticking = false;
        });

        ticking = true;
      }
    }

    //
    // Procedures
    //

    handleScroll();

    //
    // Listeners
    //

    window.addEventListener('scroll', handleScroll);
  },
});


// WEBPACK FOOTER //
// ./src/scripts/scroll-listener.js